module.exports = __webpack_public_path__ + "img/login-information.f431523e.jpg";